<template>
  <!-- 人员详情 -->
  <div class="personnelDetail">
    <el-form
      v-if="formfather.libraryFlag == '1'"
      :disabled="status === 3 || status === 4"
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="130px"
      class="userForm"
      :status-icon="false"
    >
      <div style="text-align: center">
        <!-- hz-smart-community/sys/file/upload/face?file=&faceType=c1ubc3 -->
        <!-- :action="'/api/hz-smart-community/sys/file/upload'" -->
        <el-upload
          :action="'/api/hz-smart-community/sys/file/upload/face'"
          :data="{ faceType: libraryAbbreviation }"
          list-type="picture-card"
          :headers="{
            token: token,
          }"
          :show-file-list="false"
          :on-success="handlePictureCardPreview"
          :limit="1"
        >
          <el-icon v-if="!ruleForm.fileUrl"><plus /></el-icon>
          <img v-else :src="imgURL + ruleForm.fileUrl" />
        </el-upload>
      </div>
      <div class="formTitle"><span></span>基本信息</div>
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="国籍" prop="nationality">
            <h-selectcode
              type="countryType"
              v-model="ruleForm.nationality"
              placeholder="国籍"
            ></h-selectcode>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="人员姓名" prop="personName">
            <el-input
              v-model="ruleForm.personName"
              placeholder="姓名"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item label="特征提取" prop="sex">
            <h-selectcode
              type="sex"
              v-model="ruleForm.sex"
              placeholder="特征提取"
            ></h-selectcode>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item label="用户编号" prop="telphone">
            <el-input
              v-model="ruleForm.telphone"
              placeholder="用户编号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="性别" prop="sex">
            <h-selectcode
              type="sex"
              v-model="ruleForm.sex"
              placeholder="性别"
            ></h-selectcode>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              v-model="ruleForm.birthday"
              type="date"
              placeholder="出生日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item
            label="证件类型"
            prop="cardType"
            class="cardTypeItemStyle"
          >
            <h-selectcode
              type="card_type"
              v-model="ruleForm.cardType"
              :clearable="true"
              placeholder="证件号码"
              class="cardTypeStyle"
            ></h-selectcode>
            <!-- <el-input v-model="ruleForm.cardNumber" placeholder="证件号码">
            </el-input> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="证件号码"
            prop="cardNumber"
            class="cardTypeItemStyle"
          >
            <el-input v-model="ruleForm.cardNumber" placeholder="证件号码">
            </el-input>
          </el-form-item> </el-col
      ></el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="民族" prop="">
            <h-selectcode
              type="nationType"
              v-model="ruleForm.nation"
              placeholder="民族"
            ></h-selectcode>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话" prop="">
            <el-input v-model="ruleForm.telphone" placeholder="电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="详细地址" prop="houseId">
            <el-cascader
              ref="cascaderRef"
              @change="cascaderchange"
              v-model="ruleForm.houseId"
              :props="{
                value: 'id',
                label: 'name',
              }"
              :options="unitNameoptions"
              placeholder="详细地址"
              clearable
            >
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="居住地" prop="">
            <el-cascader
              v-model="ruleForm.registerId"
              :options="houseRentTypeList"
              :props="{ value: 'districtId', label: 'name' }"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地址" prop="registerDetail">
            <el-input v-model="ruleForm.registerDetail" placeholder="地址">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型" prop="">
            <h-selectcode
              type="nationType"
              v-model="ruleForm.nation"
              placeholder="类型"
            ></h-selectcode>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门" prop="">
            <h-selectcode
              type="nationType"
              v-model="ruleForm.nation"
              placeholder="部门"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="">
            <el-input
              v-model="ruleForm.comment"
              placeholder="备注"
              show-word-limit
              type="textarea"
            />
            <el-input v-model="ruleForm.comment" placeholder="备注"> </el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>
    <el-form
      v-else
      ref="ruleFormRef"
      :model="ruleCarForm"
      :rules="carRules"
      label-width="120px"
      class="userForm"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="车牌号" prop="carNumber">
            <el-row>
              <el-col :span="5">
                <h-selectcode
                  type="car_card_color"
                  v-model="ruleCarForm.carCardColor"
                  placeholder="车牌颜色"
                ></h-selectcode>
              </el-col>
              <el-col :span="5">
                <h-selectcode
                  type="plate_ownership"
                  v-model="ruleCarForm.carProvince"
                  placeholder="车牌省份"
                ></h-selectcode>
              </el-col>
              <el-col :span="14">
                <el-input
                  v-model="ruleCarForm.carNumber"
                  placeholder="车牌号"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="车辆品牌" prop="">
            <h-selectcode
              type="vehicle_brand"
              v-model="ruleCarForm.carBrand"
              placeholder="车辆品牌"
            ></h-selectcode>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆类型" prop="carType">
            <h-selectcode
              type="carType"
              v-model="ruleCarForm.carType"
              placeholder="车辆类型"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="车身颜色" prop="">
            <h-selectcode
              type="vehicle_color_six"
              v-model="ruleCarForm.carColor"
              placeholder="车身颜色"
            ></h-selectcode>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用性质" prop="">
            <h-selectcode
              type="carUse"
              v-model="ruleCarForm.function"
              placeholder="使用性质"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="status !== 3" class="bottomCenter">
      <h-button type="primary" @click="submitForm(ruleFormRef)">保存</h-button>
      <h-button @click="formVisible = false">取消</h-button>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
} from "vue";
import util from "@util/js";
import { ElMessage } from "element-plus";
import {
  areaselectList,
  infoQuery,
  infofaceId,
  infoByCardNum,
} from "@/api/realPopulation/realPopulation";
import {
  baseprisonsave,
  baseprisonupdate,
  baseCarSave,
} from "@/api/communityCare/communityCareApi.js";
import { Plus } from "@element-plus/icons-vue";
import _ from "lodash";
import { infoSelect } from "@/api/constant";

export default defineComponent({
  name: "PersonnelDetail",
  components: { Plus },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formfather: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "userSubmit"],
  setup(props, context) {
    const ruleFormRef = ref(null);
    const cascaderRef = ref(null);
    const state = reactive({
      imgURL: window.imgURL,
      token: localStorage.getItem("token"),
      defaultPassword: "kzga110",
      formVisible: false,
      passwordType: 1,
      ruleForm: {
        personName: "", // 姓名
        cardNumber: "", // 证件号码
        cardType: "0", // 证件类型
        // nationality: "43", // 国籍
        // sex: "0", // 性别
        // birthday: "", // 出生日期
        // nation: "1", // 民族
        // telphone: "", // 电话
        // comment: "", // 备注,
        // houseId: "",
        // registerDetail: "",
        // regionId: 1, // 区域id
        // libraryId: 0, // 库id
        fileId: "",
        fileUrl: "",
        // libraryId: 645
      },
      fileUrldata: "",
      libraryAbbreviation: "",
      houseRentTypeList: [], // 居住现状
      ruleFormBack: {},
      rules: {
        personName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        cardNumber: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
      },
      ruleCarForm: {
        carCardColor: "",
        carProvince: "",
        carNumber: "",
        carBrand: "",
        carType: "",
        carColor: "",
        function: "",
        libraryId: props.formfather.libraryId,
      },
      carRules: {
        carNumber: [
          {
            required: true,
            message: "请输入车牌号",
            trigger: "blur",
          },
        ],
        carType: [
          {
            required: true,
            message: "请选择车辆类型",
            trigger: "blur",
          },
        ],
      },
      unitNameoptions: [],
      unitNameoptionsNode: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    const refData = toRefs(state);
    // 初始化表单
    const initForm = async () => {
      if (props.status === 1) {
        state.ruleForm.libraryId = props.formfather.libraryId;
      }
      ruleFormRef.value && ruleFormRef.value.resetFields();
      if (props.status === 2 || props.status === 3) {
        // const res = await infoQuery(props.form.prisonId);
        // const form = { ...state.ruleForm, ...res.prisonInfo };
        // form.houseId =
        //   res.prisonInfo.houseId && res.prisonInfo.houseId.toString();
        // state.ruleForm = _.cloneDeep(form);
        const form = { ...props.form };
        if (props.formfather.libraryFlag == "1") {
          state.fileUrldata = form.fileUrl;
          state.ruleForm = _.cloneDeep(form);
        } else {
          state.ruleCarForm = _.cloneDeep({ ...state.ruleCarForm, ...form });
          util.formatForm(state.ruleCarForm);
          console.log(state.ruleCarForm);
          for (let it in state.ruleCarForm) {
            state.ruleCarForm[it] = state.ruleCarForm[it] + "";
          }
        }
      }
      if (props.status === 4) {
        const form = { ...props.form };
        state.ruleForm = _.cloneDeep(form);
        // infoByCardNum
      }
    };
    // 监听
    watch(
      () => state.formVisible,
      (v) => {
        initForm();
        if (props.formfather.libraryAbbreviation) {
          state.libraryAbbreviation = props.formfather.libraryAbbreviation;
        }
      }
    );
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    const methods = {
      async infoSelectAxios() {
        const params = {
          type: 0,
        };
        const res = await infoSelect(params);
        const rootPid = res.top.map((item) => {
          return item.toString();
        });
        const options = { pid: "parentId", id: "id", rootPid };
        const treeData = util.arrayToTree(res.list, options);
        state.unitNameoptionsNode = res.list;
        state.unitNameoptions = treeData;
      },
      async submitForm(formEl) {
        if (!formEl) return;
        formEl.validate(async (valid) => {
          if (valid) {
            let res;
            // if (state.ruleForm.registerId) {
            //   state.ruleForm.registerId =
            //     state.ruleForm.registerId[state.ruleForm.registerId.length - 1];
            // }
            if (props.status === 1) {
              if (props.formfather.libraryFlag == "1") {
                state.ruleForm.fileUrl = state.fileUrldata;
                res = await baseprisonsave(state.ruleForm);
              } else {
                res = await baseCarSave(state.ruleCarForm);
              }
            }
            if (props.status === 2) {
              if (props.formfather.libraryFlag == "1") {
                state.ruleForm.fileUrl = state.fileUrldata;
                res = await baseprisonupdate(state.ruleForm);
              } else {
                res = await baseCarSave(state.ruleCarForm);
              }
            }
            if (res.code === 0) {
              ElMessage.success(props.status === 1 ? "添加成功" : "修改成功");
              context.emit("submit");
              state.formVisible = false;
              context.emit("update:modelValue", state.formVisible);
            }
          } else {
            console.log("error submit!");
            return false;
          }
        });
      },
    };
    methods.infoSelectAxios();
    const handlePictureCardPreview = (file) => {
      state.ruleForm.fileUrl = file.data.fileUrl;
      state.ruleForm.fileId = file.data.fileId;
      state.fileUrldata = file.data.fileUrl;
    };
    // 地址
    const regist = async () => {
      const res = await areaselectList();
      const newlist = res.districtList;
      const options = { pid: "parentId", id: "districtId", rootPid: 100000 };
      state.houseRentTypeList = util.arrayToTree(newlist, options); // 数组,参数
    };
    regist();
    // 详细地址的判断
    const cascaderchange = (val) => {
      if (val) {
        const value = val[val.length - 1];
        state.unitNameoptionsNode.forEach((item) => {
          if (item.id === value) {
            if (item.type === 7) {
              state.ruleForm.houseId = item.id;
            } else {
              console.log(cascaderRef.value);
              state.ruleForm.houseId = val;
              ElMessage({
                type: "warning",
                message: "请具体选择到房屋",
              });
            }
          }
        });
      }
    };
    return {
      ...refData,
      ...methods,
      cascaderchange,
      handlePictureCardPreview,
      ruleFormRef,
      cascaderRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.personnelDetail {
  .userForm {
    width: 100%;
    max-height: 500px;
    overflow: auto;
    padding: 20px;
    img {
      width: 100%;
      height: 100%;
    }
    :deep(.el-upload--picture-card) {
      width: 100px;
      height: 100px;
      font-size: 16px !important;
      .el-icon {
        margin-top: 36px !important;
      }
    }
    :deep(input) {
      // background-color: transparent !important;
      // height: 29px !important;
      box-sizing: border-box !important;
    }
    :deep(.el-select) {
      width: 100%;
    }
    :deep(.el-input) {
      width: 100%;
    }
    // :deep(.el-input__inner) {
    //   background: #fff !important;
    //   height: 29px !important;
    // }
    :deep(.el-cascader) {
      width: 100%;
    }
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
  .margLeftLabel {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .bottomCenter {
    display: flex;
    justify-content: center;
    border-top: 1px solid;
    border-color: #eee;
    padding-top: 16px;
  }
  :deep(.el-input-group__prepend) {
    width: 150px;
    height: 100%;
    padding-right: 0px !important;
    box-sizing: border-box;
    .HSelectcode {
      width: 115% !important;
    }
  }
  .h-input {
    height: 29px !important;
    :deep(.select-trigger) {
      height: 100%;
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
        }
      }
    }
  }
  .cardTypeItemStyle {
    /deep/.el-form-item__content {
      flex-wrap: nowrap;
    }

    .cardTypeStyle {
      width: 100%;
    }
  }
}
</style>
